import angular from 'angular';
import constants from 'app/constants';
import {
  bcpDataService,
  loaderService,
  ssDialogService
} from 'app/services';
import {
  alerts
} from 'app/components/global';
import controller from './edit-health-resources-dialog.controller';
import template from './edit-health-resources-dialog.html';

// Validation
import assessmentHealthResourceMessagesTpl from './messages/healthResource.messages.html';
import assessmentHealthResourceContactMessagesTpl from './messages/healthResource.contact.messages.html';
import assessmentHealthResourcePhoneMessagesTpl from './messages/healthResource.phone.messages.html';
import assessmentHealthResourceWebsiteMessagesTpl from './messages/healthResource.website.messages.html';


class dialogService {
  getOptions($event, { healthResource }) {
    return {
      controller,
      controllerAs: 'editHealthResourcesDialogVM',
      locals: {
        healthResource
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.advisory.bcp.editHealthResourcesDialog', [
  alerts,
  bcpDataService,
  constants,
  loaderService,
  ssDialogService,
])
  .service('editHealthResourcesDialog', dialogService)
  .run(($templateCache) => {
    $templateCache.put('healthResource.messages.html', assessmentHealthResourceMessagesTpl);
    $templateCache.put('healthResource.contact.messages.html', assessmentHealthResourceContactMessagesTpl);
    $templateCache.put('healthResource.phone.messages.html', assessmentHealthResourcePhoneMessagesTpl);
    $templateCache.put('healthResource.website.messages.html', assessmentHealthResourceWebsiteMessagesTpl);
  })
  .name;
